<template>
<div>
  <el-row type="flex" class="title-bar" :style="'justify-content:' + (operationFlag ? 'flex-end;' : 'space-between;')">
    <w-perf-analysis-time-info v-if="!operationFlag" :ref="timeInfoRef" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataReLoad" />
    <div class="vertical-center-box">
      <el-radio-group class="mr-r10" v-model="lockType">
        <el-radio :label="lockTypeData.lock" @change="onLockTypeChange">Lock</el-radio>
        <el-radio :label="lockTypeData.deadLock" @change="onLockTypeChange">Dead Lock</el-radio>
        <el-radio :label="lockTypeData.latch" @change="onLockTypeChange">Latch</el-radio>
      </el-radio-group>
      <el-select v-show="lockType == lockTypeData.lock" class="mr-r4" style="width:150px" v-model="lockMode" @change="onLockModeChange">
        <el-option v-for="item in lockModeData" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <w-header-search-button @click="onShowSearchButtonClick"></w-header-search-button>
    </div>
  </el-row>
  <!-- Lock -->
  <el-table-wrapper v-show="lockTypeData.lock === lockType" v-loading="lock.loading" :data="lock.filteredData" :columns="lockColumns" :pagination="true" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="lock.showSearchTool">
    <template slot-scope="scope" slot="sql-slot">
      <span class="link c-pointer" @click="showSqlDetailPopup(scope.row)">{{scope.row[scope.column.property]}}</span>
    </template>
  </el-table-wrapper>
  <!-- DeadLock -->
  <el-table-wrapper v-show="lockTypeData.deadLock === lockType" v-loading="deadLock.loading" :data="deadLock.tableData" :columns="deadLock.columns" :pagination="true" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="deadLock.showSearchTool">
  </el-table-wrapper>
  <!-- Latch -->
  <el-table-wrapper v-show="lockTypeData.latch === lockType" v-loading="lock.loading" :data="latch.tableData" :columns="latch.columns" :pagination="true" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="latch.showSearchTool">
  </el-table-wrapper>
  <w-dbsession-sql-query-show-popup ref="sqlDetailPopup" />
</div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import filter from 'lodash/filter';
import isNil from 'lodash/isNil';
import { convertThousandSeparatorFormat } from '@/utils/number';
import msgUtil from '@/utils/message';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { analysisTimeType } from '@/constants/performance';
import { columnDefault } from '@/constants/table';
import databaseTableInfoAPI from '@/api/performance/database/database-table-info';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';
import AnalysisTableMixin from '@/mixins/performance/analysis-table-ex';
import WDbsessionSqlQueryShowPopup from '../../../popup/DbsessionSqlQueryShowPopup';

const lockTypeData = {
  lock: 'LOCK',
  deadLock: 'DEAD_LOCK',
  latch: 'LATCH',
};
export default {
  name: 'WDbLockOracleTable',
  mixins: [AnalysisTableMixin],
  components: {
    WPerfAnalysisTimeInfo,
    WDbsessionSqlQueryShowPopup,
  },
  data() {
    return {
      loading: false,
      checkDatetime: null,
      columnDefault,
      lockTypeData,
      lockType: lockTypeData.lock,
      lock: {
        loading: false,
        showSearchTool: false,
        columns: [
          {
            prop: 'SID',
            label: '세션 아이디',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'SERIAL',
            label: '일련 번호',
            sortable: true,
            searchable: true,
            formatter: this.convertThousandSeparatorFormat,
          },
          {
            prop: 'USERNAME',
            label: '사용자',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'TERMINAL',
            label: '터미널',
            sortable: true,
            searchable: true,
            formatter: this.formatterForTerminal,
          },
          {
            prop: 'PROGRAM',
            label: '프로그램명',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'STATUS',
            label: '세션 상태',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'LOCK_TYPE',
            label: 'Lock 타입',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'HELD',
            label: 'Lock 모드',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'OBJ_NAME',
            label: '관리대상명',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'OBJ_ID',
            label: '관리대상 아아디',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'REQ_MODE',
            label: '요청 모드',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'CTIME',
            label: '대기시간(초)',
            sortable: true,
            searchable: true,
            formatter: this.convertThousandSeparatorFormat,
          },
        ],
        tableData: [],
        filteredData: [],
      },
      lockMode: 'ALL',
      lockModeData: [
        {
          value: 'ALL',
          label: '전체',
        },
        {
          value: 'Exclusive',
          label: 'Exclusive',
        },
        {
          value: 'S/Row-X (SSX)',
          label: 'S/Row-X (SSX)',
        },
        {
          value: 'Row-X (SX)',
          label: 'Row-X (SX)',
        },
        {
          value: 'Row-S (SS)',
          label: 'Row-S (SS)',
        },
        {
          value: 'Share',
          label: 'Share',
        },
        {
          value: 'None',
          label: 'None',
        },
        {
          value: 'Null',
          label: 'Null',
        },
      ],
      deadLock: {
        loading: false,
        showSearchTool: false,
        tableData: [],
        columns: [
          {
            prop: 'SID',
            label: '세션 ID',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'SERIAL',
            label: '일련번호',
            sortable: true,
            searchable: true,
            formatter: this.convertThousandSeparatorFormat,
          },
          {
            prop: 'USERNAME',
            label: 'USRNAME',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'LOCK_TYPE',
            label: 'Lock 타입',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'HELD',
            label: 'Lock 모드',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'OBJ_NAME',
            label: '관리대상명',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'OBJ_ID',
            label: '관리대상 아이디',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'REQ_MODE',
            label: '요청 모드',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'CTIME',
            label: '대기시간(초)',
            sortable: true,
            searchable: true,
            formatter: this.convertThousandSeparatorFormat,
          },
        ],
      },
      latch: {
        loading: false,
        showSearchTool: false,
        tableData: [],
        columns: [
          {
            prop: 'ADDR',
            label: '주소',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'LATCH',
            label: 'Latch',
            sortable: true,
            searchable: true,
            formatter: this.convertThousandSeparatorFormat,
          },
          {
            prop: 'LEVEL',
            label: '레벨',
            sortable: true,
            searchable: true,
            formatter: this.convertThousandSeparatorFormat,
          },
          {
            prop: 'NAME',
            label: 'Latch 명',
            sortable: true,
            searchable: true,
            formatter: this.formatterForLatchName,
          },
          {
            prop: 'GETS',
            label: 'Gets',
            sortable: true,
            searchable: true,
            formatter: this.convertThousandSeparatorFormat,
          },
          {
            prop: 'MISSES',
            label: 'Misses',
            sortable: true,
            searchable: true,
            formatter: this.convertThousandSeparatorFormat,
          },
          {
            prop: 'SPIN_GETS',
            label: 'Spin Gets',
            sortable: true,
            searchable: true,
            formatter: this.convertThousandSeparatorFormat,
          },
          {
            prop: 'SLEEPS',
            label: 'Sleeps',
            sortable: true,
            searchable: true,
            formatter: this.convertThousandSeparatorFormat,
          },
          {
            prop: 'IMMEDIATE_GETS',
            label: 'Immediate Gets',
            sortable: true,
            searchable: true,
            formatter: this.convertThousandSeparatorFormat,
          },
          {
            prop: 'IMMEDIATE_MISSES',
            label: 'Immeditate Misses',
            sortable: true,
            searchable: true,
            formatter: this.convertThousandSeparatorFormat,
          },
          {
            prop: 'WAITS_HOLDING_LATCH',
            label: 'Waits Holding Latch',
            sortable: true,
            searchable: true,
            formatter: this.convertThousandSeparatorFormat,
          },
          {
            prop: 'WAIT_TIME',
            label: '대기 시간 (초)',
            sortable: true,
            searchable: true,
            formatter: this.convertThousandSeparatorFormat,
          },
        ],
      },
    };
  },
  computed: {
    lockColumns() {
      if (this.timeType === analysisTimeType.HIST.value && !this.operationFlag) {
        return this.lock.columns;
      }
      const columns = cloneDeep(this.lock.columns);
      columns.push({
        label: 'SQL문',
        align: 'center',
        scopedSlot: 'sql-slot',
        width: 60,
      });
      return columns;
    },
  },
  methods: {
    /**
     * 데이터틀 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      if (this.lockTypeData.lock === this.lockType) {
        this.loadLockData();
      } else if (this.lockTypeData.deadLock === this.lockType) {
        this.loadDeadLockData();
      } else {
        this.loadLatchData();
      }
    },
    /**
     * 스냅샷 파라미터를 반환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    getSnapshotParams() {
      return {
        objId: this.selectedNode.obj.objId,
        baselineDatetime: this.plotLineDatetime,
        managetypeId: 'DBMS',
      };
    },
    /**
     * Lock 정보를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadLockData() {
      if (this.timeType === analysisTimeType.CURRENT.value || this.operationFlag) {
        const params = {
          objId: this.selectedNode.obj.objId,
          queryId: 'DBORLockInfo',
        };
        this.lock.loading = true;
        databaseTableInfoAPI
          .getDbLockInfoByQuery(params)
          .then((result) => {
            if (result.data.success === true) {
              this.lock.tableData = result.data.data;
              this.onLockModeChange();
            }
          })
          .catch(() => {
            this.failToLoadLockData();
          })
          .finally(() => {
            this.lock.loading = false;
          });
      } else {
        const params = this.getSnapshotParams();
        this.lock.loading = true;
        databaseTableInfoAPI
          .getOracleLockSnapthot(params)
          .then((result) => {
            if (result.data.success === true) {
              const snapshotData = result.data.data;
              this.lock.tableData = snapshotData.snapshotDoc;
              this.checkDatetime = snapshotData.timestamp;
              this.onLockModeChange();
            }
          })
          .catch(() => {
            this.failToLoadLockData();
          })
          .finally(() => {
            this.lock.loading = false;
          });
      }
    },
    /**
     * Lock 데이터 조회 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadLockData() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'Lock 정보', false));
    },
    /**
     * Dead Lock 정보를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadDeadLockData() {
      if (this.timeType === analysisTimeType.CURRENT.value || this.operationFlag) {
        const params = {
          objId: this.selectedNode.obj.objId,
          queryId: 'DBORDeadLockInfo',
        };
        this.deadLock.loading = true;
        databaseTableInfoAPI
          .getDbLockInfoByQuery(params)
          .then((result) => {
            if (result.data.success === true) {
              this.deadLock.tableData = result.data.data;
            }
          })
          .catch(() => {
            this.failToLoadDeadLockData();
          })
          .finally(() => {
            this.deadLock.loading = false;
          });
      } else {
        const params = this.getSnapshotParams();
        this.deadLock.loading = true;
        databaseTableInfoAPI
          .getOracleDeadLockSnapthot(params)
          .then((result) => {
            if (result.data.success === true) {
              const snapshotData = result.data.data;
              this.deadLock.tableData = snapshotData.snapshotDoc;
              this.checkDatetime = snapshotData.timestamp;
            }
          })
          .catch(() => {
            this.failToLoadDeadLockData();
          })
          .finally(() => {
            this.deadLock.loading = false;
          });
      }
    },
    /**
     * Dead Lock 데이터 조회 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadDeadLockData() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'Dead Lock 정보', false));
    },
    /**
     * Latch 데이터 로드
     * @author Ju
     * @return {[type]} [description]
     */
    loadLatchData() {
      if (this.timeType === analysisTimeType.CURRENT.value || this.operationFlag) {
        const params = {
          objId: this.selectedNode.obj.objId,
          queryId: 'DBORLatchInfo',
        };
        this.latch.loading = true;
        databaseTableInfoAPI
          .getDbLockInfoByQuery(params)
          .then((result) => {
            if (result.data.success === true) {
              this.latch.tableData = result.data.data;
            }
          })
          .catch(() => {
            this.failToLoadLatchData();
          })
          .finally(() => {
            this.latch.loading = false;
          });
      } else {
        const params = this.getSnapshotParams();
        this.latch.loading = true;
        databaseTableInfoAPI
          .getOracleLatchLockSnapthot(params)
          .then((result) => {
            if (result.data.success === true) {
              const snapshotData = result.data.data;
              this.latch.tableData = snapshotData.snapshotDoc;
              this.checkDatetime = snapshotData.timestamp;
            }
          })
          .catch(() => {
            this.failToLoadLatchData();
          })
          .finally(() => {
            this.latch.loading = false;
          });
      }
    },
    /**
     * Latch 데이터 조회 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadLatchData() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'Latch 정보', false));
    },
    /**
     * Lock 타입 변경 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onLockTypeChange() {
      this.loadData();
    },
    /**
     * 헤더 검새 버튼 클릭 이벤튼 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onShowSearchButtonClick() {
      if (this.lockType === this.lockTypeData.lock) {
        this.lock.showSearchTool = !this.lock.showSearchTool;
      } else if (this.lockType === this.lockTypeData.deadLock) {
        this.deadLock.showSearchTool = !this.deadLock.showSearchTool;
      } else {
        this.latch.showSearchTool = !this.latch.showSearchTool;
      }
    },
    /**
     * Lock Mode 변경 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onLockModeChange() {
      this.lock.filteredData = this.lockMode === 'ALL' ? this.lock.tableData : filter(this.lock.tableData, (item) => item.HELD === this.lockMode);
    },
    /**
     * SQL문 상세 팝업을 연다.
     * @author Ju
     * @param  {[type]} row 세션 정보
     */
    showSqlDetailPopup(row) {
      this.$refs.sqlDetailPopup.open(row);
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 천 단위마다 콤마 표시
     * @author Ju
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    convertThousandSeparatorFormat(row, column, value) {
      return convertThousandSeparatorFormat(value);
    },
    /**
     * Terminal Formatter
     * @author Ju
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    formatterForTerminal(row, column, value) {
      return value === '_' ? '_Total' : value;
    },
    /**
     * Latch Name Formatter
     * @author Ju
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    formatterForLatchName(row, column, value) {
      return isNil(value) ? 0 : value;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/database/components/table/DbLock/DbLockOracleTable.vue